// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"eccfd803","550":"4b5305e4","787":"d4c10e0b"}[chunkId] + ".chunk.js";
};